export { default } from './ContentWithItems';
